import * as React from 'react'
import { forwardRef, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MaterialTable from 'material-table'
import { timeout } from '../../App'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import GridItem from '../grid/GridItem'
import GridContainer from '../grid/GridContainer'
import { AddAlert, Close } from '@material-ui/icons'
import Snackbar from '../snackbar/Snackbar'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Slide from '@material-ui/core/Slide'
import { initialNotificationState } from '../utils/state/ApplicationState'
import styles from 'assets/jss/dorm-app/views/notificationsStyle.js'
import RegularButton from '../button/RegularButton'
import { getApiUrl } from '../../api/api'

const useStyles = makeStyles(styles)

const columns = [
  { title: 'Referat', field: 'department' },
  { title: 'Semester', field: 'semester' },
  { title: 'Name', field: 'tenantName' },
  { title: 'Email', field: 'tenantEmail' },
  { title: 'Zimmer', field: 'tenantRoom' },
  { title: 'Flur', field: 'tenantFloor' },
  { title: 'Punkte', field: 'points', customSort: (a, b) => parseFloat(a.points) - parseFloat(b.points) },
  { title: 'Notiz', field: 'note' },
]

export default function DepartmentCompensatedEngagements() {
  const classes = useStyles()

  const [fetchData, setFetchData] = useState(false)
  const [proceeding, setProceeding] = useState(true)
  const [engagements, setEngagements] = useState(null)
  const [engagementId, setEngagementId] = useState(null)
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(initialNotificationState)

  const Transition = forwardRef(function transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />
  })

  const deleteAction = () => {
    setModal(false)
    // const options = {
    //   headers: { Authorization: `Bearer ${user.token}` },
    // }

    getApiUrl()
      .delete(`/api/engagements/${engagementId}`)
      .then(function() {
        setFetchData(!fetchData)
        setNotification({
          open: true,
          message: 'Amt wurde gelöscht',
          color: 'success',
        })
      })
      .catch(function(error) {
        setFetchData(!fetchData)
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  useEffect(() => {
    setProceeding(true)
    getApiUrl({ compensated: 'true' })
      .get(`/api/engagements`)
      .then(function(response) {
        setProceeding(false)
        setEngagements(response.data)
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [fetchData])

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <MaterialTable
          columns={columns}
          data={engagements != null ? engagements : []}
          actions={[
            {
              icon: 'edit',
              tooltip: 'Eintrag bearbeiten',
              onClick: (event, rowData) => {
                window.open(`/departments/info/engagements/${rowData.engagementId}`, '_blank')
                event.stopPropagation()
              },
            },
            {
              icon: 'delete',
              tooltip: 'Eintrag löschen',
              onClick: (event, rowData) => {
                event.stopPropagation()
                setEngagementId(rowData.engagementId)
                setModal(true)
              },
            },
          ]}
          title=""
          options={{
            pageSize: 30,
            pageSizeOptions: [10, 30, 50],
            headerStyle: {
              fontWeight: 600,
            },
          }}
          localization={{
            pagination: {
              labelDisplayedRows: '{from}-{to} von {count}',
              labelRowsSelect: 'Einträge',
              labelRowsPerPage: 'Zeilen pro Seite',
            },
            toolbar: {
              nRowsSelected: '{0} Zeile(n) ',
              searchPlaceholder: 'Suchen',
              searchTooltip: 'Suchen',
            },
            header: {
              actions: 'Aktion',
            },
            body: {
              emptyDataSourceMessage: 'Keine Daten vorhanden.',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
        />
      </GridItem>
      <Snackbar
        place="br"
        color={notification.color}
        icon={AddAlert}
        message={notification.message}
        open={notification.open}
        closeNotification={() =>
          setNotification({
            open: false,
            message: '',
            color: '',
          })
        }
        close
      />
      <Dialog
        classes={{
          root: classes.center + ' ' + classes.modalRoot,
          paper: classes.modal + ' ' + classes.modalSmall,
        }}
        open={modal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setModal(false)}
        aria-labelledby="small-modal-slide-title"
        aria-describedby="small-modal-slide-description">
        <DialogTitle id="small-modal-slide-title" disableTypography className={classes.modalHeader}>
          <RegularButton
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setModal(false)}>
            <Close className={classes.modalClose}/>
          </RegularButton>
        </DialogTitle>
        <DialogContent id="small-modal-slide-description" className={classes.modalBody + ' ' + classes.modalSmallBody}>
          <h5>Willst du den eintrag löschen?</h5>
        </DialogContent>
        <DialogActions className={classes.modalFooter + ' ' + classes.modalFooterCenter}>
          <RegularButton
            onClick={() => setModal(false)}
            color="transparent"
            className={classes.modalSmallFooterFirstButton}>
            Zurück
          </RegularButton>
          <RegularButton
            onClick={deleteAction}
            color="success"
            simple
            className={classes.modalSmallFooterFirstButton + ' ' + classes.modalSmallFooterSecondButton}>
            Ja, löschen
          </RegularButton>
        </DialogActions>
      </Dialog>
    </GridContainer>
  )
}
